import { useParams } from "react-router-dom";
import { RootState } from "@/store/store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CashierBranchesModal from "@/components/Cashier/CashierBranchesModal";
import { ProductBranch } from "@/types/globalTypes";
import axios from "axios";
import { clearBranch, setBranch } from "@/store/BranchSlice";
import TablesLogicWrapper from "@/components/tables/TablesLogicWrapper";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import GroupedOrderTable from "./GroupedOrderTable";


function Tables() {
  const { floorId,tableId } = useParams(); // Check if there's a grouped order ID
  const { t } = useTranslation();

  const [branchModalOpen, setBranchModalOpen] = useState(false);
  useLockBodyScroll(branchModalOpen);
  const [branches, setBranches] = useState<ProductBranch[]>([]);
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );
  const dispatch = useDispatch();
  const branch = useSelector((state: RootState) => state.branch.branch);
  const [selectedBranch, setSelectedBranch] = useState<ProductBranch | null>(
    null,
  );

  async function getBranches() {
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/branches/list`,
        method: "GET",
        headers: {
          Authorization: token,
        },
      };
      const response = await axios.request(options);
      setBranches(response.data.branches);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (!branch || !branches?.length) return;

    const currentBranch = branches.find(
      (e) => String(e._id) === String(branch._id),
    );
    if (currentBranch?.availability === 0) {
      setSelectedBranch(currentBranch);
      dispatch(setBranch(currentBranch));
    } else {
      setSelectedBranch(null);
      dispatch(clearBranch());
      setBranchModalOpen(true);
    }
  }, [branch, branches, dispatch]);

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!branch) {
      setBranchModalOpen(true);
    }
  }, [branch]);

  // ✅ If there's an ID param, render only GroupedOrderTable
  if (floorId && tableId) {
    return <GroupedOrderTable />;
  }

  // Show modal if no branch selected
  if (!branch) {
    return (
      <CashierBranchesModal
        setSelectedBranch={setSelectedBranch}
        branches={branches}
        selectedBranch={selectedBranch}
        setBranchModalOpen={setBranchModalOpen}
      />
    );
  }

  return (
    <div className="flex flex-col gap-7">
      {branchModalOpen && (
        <CashierBranchesModal
          setSelectedBranch={setSelectedBranch}
          branches={branches}
          selectedBranch={selectedBranch}
          setBranchModalOpen={setBranchModalOpen}
        />
      )}
      <button
        onClick={() => setBranchModalOpen(true)}
        className="my-btn w-fit px-5 py-1"
      >
        {branch
          ? i18n.language === "ar"
            ? branch.nameAR
            : branch.nameEN
          : t("branches.select")}
      </button>
      {branch && branch._id && <TablesLogicWrapper branchId={branch._id} />}
    </div>
  );
}

export default Tables;
